import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { Button } from '@/components/ui/button';
import ResearchPic from '@/assets/Onboarding/BlignyResearchPic.png';
import { PatientPageLayout } from '@/components/PatientPageLayout';

export const RechercheCliniquePage = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <h1 className="text-center text-1.5xl font-medium">
          Recherche clinique
        </h1>
      }
      titleClassName="text-center"
      contentClassName="flex flex-col items-center justify-center text-center"
      footer={
        <div className="flex w-full max-w-[330px] flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Continuer
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-2 px-4">
        <img
          src={ResearchPic}
          alt="Médecin expliquant le questionnaire"
          className="max-w-86"
        />
        <p className="text-center font-light leading-5 mt-2">
          Nous vous informons que les données recueillies via ce questionnaire
          pourront être utilisées ultérieurement, de{' '}
          <span className="font-semibold">façon anonymisée</span>, par le CH de
          Bligny dans le cadre d&apos;une étude rétrospective visant à évaluer
          l&apos;efficacité du dispositif Aldebaran. Vous pouvez vous y opposer
          sans que cela ne modifie les soins que vous recevrez.
        </p>
        <p className="text-xs text-gray-500 text-center mt-6">
          Pour plus de détails, vous pouvez{' '}
          <a
            href="https://www.chbligny.fr/storage/2025/11/etude-aldebaran_note-information_v1.0-19nov2025.pdf"
            className="underline cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            consulter la notice d&apos;information{' '}
          </a>
          concernant la recherche complète. <br /> <br /> Si vous souhaitez vous
          opposer à l&apos;utilisation de vos données, veuillez{' '}
          <a
            href="https://www.chbligny.fr/storage/2025/11/etude-aldebaran_formulaire-d-opposition_v1.0-19nov2025.pdf"
            className="underline cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            compléter le formulaire d&apos;opposition{' '}
          </a>
          .
        </p>
      </div>
    </PatientPageLayout>
  );
};
